import React, { useState, useEffect } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';

/**
 * "Redeem loyalty points" on the checkout: one tap uses as many of the member's points as the order can take (the server caps it at what is payable and
 * keeps the rest). `offer` is the server's `loyalty` block of the checkout summary; when it is there the box shows that capped amount.
 */
export default function LoyaltyPoints({ orderId, tableId, onSelect, offer }) {
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [loyaltyAmount, setLoyaltyAmount] = useState(0);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const fetchLoyaltyPoints = async () => {
      if (!orderId && !tableId) return;

      let url = `${apiUrls.OFFERS_LOYALTY_POINTS}?type=loyalty_points`;
      if (tableId) url += `&table_id=${tableId}`;
      else if (orderId) url += `&order_id=${orderId}`;

      try {
        // withLoader=false - loyalty points are secondary; don't hold the
        // global loader open waiting on this while the rest of checkout
        // (cart items, summary, tender view) is already usable.
        const response = await callAPI(url, {}, 'GET', null, {}, {}, false);
        if (response.status === 200 && response.data?.data?.loyalty_points) {
          const lp = response.data.data.loyalty_points;
          setLoyaltyPoints(lp.loyalty_points || 0);
          setLoyaltyAmount(lp.loyalty_points_amount || 0);
        }
      } catch (error) {
        console.error('Error fetching loyalty points:', error);
      }
    };

    fetchLoyaltyPoints();
  }, [orderId, tableId]);

  const handleChange = () => {
    setIsChecked(!isChecked);
    if (onSelect) {
      // notify parent (amount, points): what one tap takes off this order when the server said so, else the whole balance
      const amount = offer && Number(offer.redeemable_amount) > 0 ? Number(offer.redeemable_amount) : loyaltyAmount;
      const points = offer && Number(offer.redeemable_points) > 0 ? Number(offer.redeemable_points) : loyaltyPoints;
      onSelect(!isChecked ? amount : 0, !isChecked ? points : 0);
    }
  };

  if (loyaltyPoints === 0) return null; // hide if no points available

  // what one tap would take off this order (capped at the order total), else the member's whole balance
  const shownAmount = offer && Number(offer.redeemable_amount) > 0 ? Number(offer.redeemable_amount) : loyaltyAmount;
  if (offer && !isChecked && !(Number(offer.redeemable_amount) > 0)) return null; // the order has nothing left to take points off

  return (
    <div className="cardLgCol">
      <h4 className="lgTitle">Pay with Loyalty Points</h4>
      <div className="form-group checkStyle">
        <input
          type="checkbox"
          id="loyalty"
          checked={isChecked}
          onChange={handleChange}
        />
        <label htmlFor="loyalty" style={{paddingLeft:"10px"}}>
          Redeem loyalty points (<span>{shownAmount}</span>)
        </label>
      </div>
    </div>
  );
}
